import { SkeletonLoader } from '@/components/SkeletonLoader';

export function MeetingRoomCardSkeleton() {
  return (
    <div className="flex flex-col gap-5 min-[1300px]:flex-row text-teal-40 flex-nowrap">
      <SkeletonLoader className="w-full h-[180px] min-[1300px]:w-[150px] min-[1300px]:h-[100px] flex-shrink-0" />

      <div className="flex flex-col flex-grow gap-2">
        <SkeletonLoader className="w-full h-6 lg:w-2/3" />
        <SkeletonLoader className="w-3/5 h-6 lg:w-1/4" />
        <SkeletonLoader className="w-4/5 h-6 lg:w-1/3" />
      </div>
    </div>
  );
}
